/* lua.js generated code 0.3.0 */

var GameGuideData = require("clover/gameGuide/GameGuideData")
var GameGuideTrigger = {}
GameGuideTrigger.preCheck = function (keyword, paras) {
    var funcName = string.upper(string.sub(tostring(keyword), 1, 1)) + string.sub(tostring(keyword), 2)
    if (type(GameGuideTrigger["pre" + tostring(funcName)]) === "function") {
        GameGuideTrigger["pre" + tostring(funcName)](paras)
    }
}
GameGuideTrigger.postRun = function (keyword, paras) {
    var funcName = string.upper(string.sub(tostring(keyword), 1, 1)) + string.sub(tostring(keyword), 2)
    if (type(GameGuideTrigger["post" + tostring(funcName)]) === "function") {
        GameGuideTrigger["post" + tostring(funcName)](paras)
    }
}
GameGuideTrigger.preGameSecondSelectProp = function (paras) {
    GameGuideData.getInstance().addToGameFlags("secondSelectProp")
}
GameGuideTrigger.postGameSecondSelectProp = function (paras) {
    GameGuideData.getInstance().removeFromGameFlags("secondSelectProp")
}
GameGuideTrigger.preGameCancelUseProp = function (paras) {
    var data = GameGuideData.getInstance()
    data.addToGameFlags("cancelUseProp")
}
GameGuideTrigger.postGameCancelUseProp = function (paras) {
    GameGuideData.getInstance().removeFromGameFlags("cancelUseProp")
}
GameGuideTrigger.preGameConfirmUseProp = function (paras) {
    var data = GameGuideData.getInstance()
    data.setGameWaiting(false)
    data.addToGameFlags("confirmUseProp")
}
GameGuideTrigger.postGameConfirmUseProp = function (paras) {
    GameGuideData.getInstance().removeFromGameFlags("confirmUseProp")
}
GameGuideTrigger.preEnterScene = function (paras) {
    var scene = cc.Director.getInstance().getRunningScene()
    var data = GameGuideData.getInstance()
    data.setScene(((scene || table()).class || table()).__cname)
    data.setLevelId((scene || table()).levelID)
    data.resetNumMoves()
    data.resetSkipLevel()
    data.resetGameFlags()
    data.resetGuideInLevel()
    data.resetCurLevelGuide()
    data.resetGameWaiting()
    data.resetFishSpawnWave()
    data.resetLevelStage()
    data.resetGameplayFlags()
}
GameGuideTrigger.preExitScene = function (paras) {
    var data = GameGuideData.getInstance()
    data.resetScene()
    data.resetNumMoves()
    data.resetSkipLevel()
    data.resetGameFlags()
    data.resetGuideInLevel()
    data.resetCurLevelGuide()
    data.resetGameWaiting()
    data.resetFishSpawnWave()
    data.resetLevelStage()
    data.resetGameplayFlags()
}
GameGuideTrigger.prePanelRise = function (paras) {
    var data = GameGuideData.getInstance()
    data.addToGameFlags("panelRise")
    data.setPopups(data.getPopups() + 1)
}
GameGuideTrigger.prePanelSink = function (paras) {
    var data = GameGuideData.getInstance()
    data.removeFromGameFlags("panelRise")
    data.setPopups(data.getPopups() - 1)
}
GameGuideTrigger.preGameWaitingState = function (paras) {
    GameGuideData.getInstance().setGameWaiting(true)
}
GameGuideTrigger.preGameSwap = function (paras) {
    var data = GameGuideData.getInstance()
    data.resetGameplayFlags()
    data.setGameWaiting(false)
    data.addToGameFlags("gameSwap")
    data.setNumMoves(data.getNumMoves() + 1)
}
GameGuideTrigger.postGameSwap = function (paras) {
    var data = GameGuideData.getInstance()
    data.removeFromGameFlags("fishSpawn")
    data.removeFromGameFlags("gameSwap")
}
GameGuideTrigger.preGameUseProp = function (paras) {
    var data = GameGuideData.getInstance()
    data.addToGameFlags("selectProp")
}
GameGuideTrigger.postGameUseProp = function (paras) {
    GameGuideData.getInstance().removeFromGameFlags("selectProp")
}
GameGuideTrigger.preFishSpawn = function (paras) {
    var data = GameGuideData.getInstance()
    data.addToGameFlags("fishSpawn")
    data.setFishSpawnWave(data.getFishSpawnWave() + 1)
}
GameGuideTrigger.preIceStageEnter = function (paras) {
    GameGuideData.getInstance().setLevelStage(paras.stage)
}
GameGuideTrigger.preButtonShow = function (paras) {
    GameGuideData.getInstance().addToGameFlags("buttonShow")
}
GameGuideTrigger.postButtonShow = function (paras) {
    GameGuideData.getInstance().removeFromGameFlags("buttonShow")
}
GameGuideTrigger.preGameFlag = function (paras) {
    GameGuideData.getInstance().addToGameplayFlags(paras.flag)
}
GameGuideTrigger.postGameFlag = function (paras) {
    if (paras.instant) {
        GameGuideData.getInstance().removeFromGameplayFlags(paras.flag)
    }
}
GameGuideTrigger.prePropBlock = function (paras) {
    let self = this
    let data = GameGuideData.getInstance()
    data.addToGameFlags("propBlock")
    data.setPosInBoard(paras)
}
GameGuideTrigger.preScoreAnimalBuff = function (paras) {
    let self = this
    // body
    let data = GameGuideData.getInstance()
    data.addToGameFlags("scoreAnimalBuff")
    data.setPosInBoard(paras)
}
GameGuideTrigger.preJackpotAppear = function (paras) {
    let self = this
    // body
    let data = GameGuideData.getInstance()
    data.addToGameFlags("jackpotAppear")
    let posBoardFlag = data.getPosInBoardWithFlag()
    posBoardFlag[paras.key] = paras.pos
}
GameGuideTrigger.preGoldPackageAppear = function (paras) {
    let self = this
    // body
    let data = GameGuideData.getInstance()
    data.addToGameFlags("goldPackageAppear")
    let posBoardFlag = data.getPosInBoardWithFlag()
    posBoardFlag[paras.key] = paras.pos
}

module.exports = GameGuideTrigger
